import type { KeyValuePair } from './normalizeSectionInputs';

/**
 * Collect KeyValuePair[] from a container using `id` attribute for inputs, textarea, and select.
 * - Checkbox/Radio: serialize checked state as 'true'/'false'
 * - Other inputs/textarea/select: serialize string value (empty string if undefined)
 */
export function collectPairsByIdFromContainer(container: Element | null): KeyValuePair[] {
  if (!container) return [];
  const pairs: KeyValuePair[] = [];
  container.querySelectorAll('input, textarea, select').forEach((el) => {
    const id = (el as HTMLElement).getAttribute('data-field-id');
    if (!id) return;

    if (el instanceof HTMLInputElement) {
      if (el.type === 'checkbox') {
        pairs.push({ key: id, value: el.checked ? 'true' : 'false' });
      } else if (el.type === 'radio') {
        pairs.push({ key: id, value: el.checked ? 'true' : 'false' });
      } else if (el.type !== 'file') {
        pairs.push({ key: id, value: el.value ?? '' });
      }
      // skip file inputs
    } else if (el instanceof HTMLTextAreaElement) {
      pairs.push({ key: id, value: el.value ?? '' });
    } else if (el instanceof HTMLSelectElement) {
      pairs.push({ key: id, value: el.value ?? '' });
    }
  });
  return pairs;
}
